export const APP_CONFIG = {
  song: {
    maxRhythmSymbolsPerChordTile: 8,
  },
};
